import { TableColumn } from "../../types/table-column";

export const productsColumns: TableColumn[] = [
  {
    type: "string",
    fieldName: "PRODUCTS_PAGE.PRODUCT_NAME",
    value: "name",
    secondaryValue: "link",
    secondaryValueType: "URL",
    width: 17,
    hasSorting: true,
  },
  {
    type: "string",
    fieldName: "PRODUCTS_PAGE.VENDOR",
    value: "vendor",
    width: 14,
    hasSorting: true,
  },
  {
    type: "string",
    fieldName: "PRODUCTS_PAGE.VERSION",
    value: "version",
    width: 10,
    hasSorting: true,
  },
  {
    type: "string",
    fieldName: "PRODUCTS_PAGE.APPLICATION_TYPE",
    value: "type",
    width: 14,
    translatedValue: true,
    translatedObj: "PRODUCT_TYPES",
    hasSorting: true,
  },
  {
    type: "userObj",
    fieldName: "RESPONSIBLE",
    value: "responsible",
    secondaryValue: "email",
    width: 15,
    hasSorting: false,
  },
  {
    type: "date",
    fieldName: "CREATED",
    value: "created_at",
    width: 9,
    hasSorting: true,
  },
  {
    type: "date",
    fieldName: "UPDATED",
    value: "updated_at",
    width: 9,
    hasSorting: true,
  },

  {
    type: "productStatus",
    fieldName: "STATUS",
    value: "status",
    width: 13,
    hasSorting: true,
  },
  // {
  //   type: "actions",
  //   fieldName: "",
  //   value: "product",
  //   width: 1,
  // },
];
